
import { cn } from '@/lib/utils';
import { PublicLayout } from '@/components/layout/PublicLayout';
import TravelNewsSection from '@/components/public/TravelNewsSection';
import { BlogCarousel } from '@/components/blog/public/BlogCarousel';
import { Separator } from '@/components/ui/separator';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { AnimatedHeroText } from '@/components/public/AnimatedHeroText';
import { useIsMobile } from '@/hooks/use-mobile';

export default function Index() {
  const isMobile = useIsMobile();

  return (
    <main className="mx-auto">
      <div className="container px-4 sm:px-6 mx-auto">
        {/* Hero Section with animated text and dynamic background */}
        <section className="mb-8 sm:mb-16 rounded-lg overflow-hidden">
          <AnimatedHeroText 
            title="Trotting the World"
            subtitle="Wonders Unfurled! Your ultimate travel companion. Discover destinations, explore curated itineraries, and read authentic travel stories."
            className="w-full"
          />
          <div className="text-center -mt-4 sm:-mt-8 mb-8 sm:mb-10 relative z-10">
            <Link 
              to="/blog" 
              className={cn(
                "inline-flex items-center justify-center bg-blue-500 hover:bg-blue-600 text-white rounded-md transition-colors",
                isMobile ? "px-5 py-3.5 text-base min-w-40 min-h-12" : "px-6 py-3.5"
              )}
            >
              Explore Blog <ArrowRight className={cn("ml-2", isMobile ? "h-5 w-5" : "h-4 w-4")} />
            </Link>
          </div>
        </section>
        
        {/* Featured Blog Posts Carousel - full width for better visual impact */}
        <section className="mb-10 sm:mb-16 -mx-4 sm:mx-0">
          <div className="px-4 sm:px-0">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 sm:mb-8">Featured Stories</h2>
          </div>
          <BlogCarousel />
        </section>
        
        <Separator className="my-6 sm:my-12" />
        
        {/* Travel News Section - improved spacing and layout */}
        <div className="-mx-4 sm:mx-0 mb-10 sm:mb-16">
          <TravelNewsSection />
        </div>
      </div>
    </main>
  );
}
